import { ChatRoom, ChatRoomType } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore, subscribeOnChatRoomAdded } from '@dinosband/bv-main-client'
import { BvSubscriber } from './manager/subscriber'

export class HelpDeskChatRoomSubscriber extends BvSubscriber<ChatRoom> {

  mainStore: MainStore

  constructor (context: { mainStore: MainStore }, callback: (value: ChatRoom | ChatRoom[]) => void) {
    super(callback)
    this.mainStore = context.mainStore
  }

  protected async query () {
    if (!this.mainStore.userId || this.mainStore.userId <= 0) {
      return
    }
    return await this.mainStore.readHelpDeskChatRooms()
  }

  protected async subscribe () {
    if (!this.mainStore.userId || this.mainStore.userId <= 0) {
      return
    }
    if (!this.mainStore.adminChannels.length && !this.mainStore.ownChannels.length) {
      return
    }
    return subscribeOnChatRoomAdded(await this.mainStore.apollo.getClient(), this.mainStore.userId, [ChatRoomType.HELPDESK], (value) => { this.callback(value) })
  }

}
